/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {onboardSavingsYieldCustomer} from '../api'

export const useMutationOnboardSavingsYieldCustomer = createReactQueryMutationHook('onboardSavingsYieldCustomer', onboardSavingsYieldCustomer)
